import { createContext, useContext } from 'react';

export type ArtifactContextValue = {
  activeId: string | null;
  onOpen: (id: string) => void;
  onOpenFile: (relativePath: string) => void;
};

export const ArtifactContext = createContext<ArtifactContextValue>({
  activeId: null,
  onOpen: () => {
    /* default noop — ChatPage provides the real one */
  },
  onOpenFile: () => {
    /* default noop — ChatPage provides the real one */
  },
});

export function useArtifactContext(): ArtifactContextValue {
  return useContext(ArtifactContext);
}
